import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import {
  faBuilding,
  faBus,
  faCalendarAlt,
  faCartShopping,
  faCircle,
  faCreditCard,
  faHome,
  faToolbox,
  faUser,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";

// 🔥 Remove the old import, only keep the hook
import { useNavigationWithPermissions } from "../../redux/services/permissionService";

const fullNavigation = [
  {
    id: "home",
    title: "Home",
    icon: faHome,
    navLink: "/home",
    resource: "home",
  },
  {
    id: "payments",
    title: "Payments",
    icon: faCreditCard,
    navLink: "/payments",
    resource: "payments",
    subMenu: [
      {
        id: "customer-refunds",
        title: "Customer Refunds",
        navLink: "/payments/refund-orders",
        icon: faCircle,
      },
      {
        id: "return-requests",
        title: "Return Requests",
        navLink: "/payments/return-requests",
        icon: faCircle,
      },
    ],
  },
  {
    id: "configuration",
    title: "Configuration",
    icon: faToolbox,
    navLink: "/configuration",
    resource: "configuration",
    subMenu: [
      {
        id: "customize-day-available",
        title: "Products Availability",
        navLink: "/configuration/day-available",
        icon: faCircle,
      },
      {
        id: "portion-sizes",
        title: "Portion Sizes",
        navLink: "/configuration/portion-sizes",
        icon: faCircle,
      },
      {
        id: "commission",
        title: "Commission",
        navLink: "/configuration/commission",
        icon: faCircle,
      },
      {
        id: "filter-tags",
        title: "Filter Tags",
        navLink: "/configuration/filter-tags",
        icon: faCircle,
      },
      {
        id: "promotions",
        title: "Promotions",
        navLink: "/configuration/promotions",
        icon: faCircle,
      },
      {
        id: "delivery-zones",
        title: "Delivery Zones",
        navLink: "/configuration/delivery-zones",
        icon: faCircle,
      },
      {
        id: "holidays",
        title: "Holidays",
        navLink: "/configuration/holidays",
        icon: faCircle,
      },
      {
        id: "order-times",
        title: "Order Times",
        navLink: "/configuration/order-times",
        icon: faCircle,
      }
    ],
  },

  {
    id: "product-catalogue",
    title: "Product Catalogue",
    icon: faProductHunt,
    navLink: "/productCatalogue",
    resource: "products",
    subMenu: [
      {
        id: "product-groups",
        title: "Product Groups",
        navLink: "/productCatalogue/product-groups",
        icon: faCircle,
      },
      {
        id: "stock-keeping-unit",
        title: "Products (SKU)",
        navLink: "/productCatalogue/stock-keeping-unit",
        icon: faCircle,
      },
      {
        id: "combo-menu",
        title: "Combo Products",
        navLink: "/productCatalogue/combo-menu",
        icon: faCircle,
      },
      {
        id: "products",
        title: "Custom Menus",
        navLink: "/productCatalogue/products",
        icon: faCircle,
      },
    ],
  },

  {
    id: "menu",
    title: "Menu",
    icon: faUtensils,
    navLink: "/menu",
    resource: "menu",
    subMenu: [
      {
        id: "menu-list",
        title: "Menu List",
        navLink: "/menu/menu-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "orders",
    title: "Orders",
    icon: faCalendarAlt,
    navLink: "/orders",
    resource: "orders",
    subMenu: [
      {
        id: "add-order",
        title: "Add New Order",
        navLink: "/orders/create-order",
        icon: faCircle,
      },

      {
        id: "cartItem-request",
        title: "Cart Item Requests",
        navLink: "/orders/cart-item-request",
        icon: faCircle,
      },
      {
        id: "order-list",
        title: "Pickup Orders",
        navLink: "/orders/pickup-orders",
        icon: faCircle,
      },
      {
        id: "delivery-order",
        title: "Delivery Orders",
        navLink: "/orders/delivery-order",
        icon: faCircle,
      },
      {
        id: "delivery-route-optimizer",
        title: "Delivery Route Optimizer",
        navLink: "/orders/delivery-route-optimizer",
        icon: faCircle,
      },
      {
        id: "card-payment-abandoned-orders",
        title: "Abandoned Orders",
        navLink: "/orders/card-payment-abandoned-orders",
        icon: faCircle,
      },
    ],
  },
  {
    id: "customers",
    title: "Customers",
    icon: faUser,
    navLink: "/customers/*",
    resource: "customers",
    subMenu: [

      {
        id: "customer-list",
        title: "Customer List",
        navLink: "/customers/customer-list",
        icon: faCircle,
      }
    ],
  },
  {
    id: "organizations",
    title: "Organizations",
    icon: faBuilding,
    navLink: "/organizations/*",
    resource: "organizations",
    subMenu: [
      {
        id: "organization-list",
        title: "Organization List",
        navLink: "/organizations/organization-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "carts",
    title: "Carts & Trolleys & Cartes",
    icon: faCartShopping,
    navLink: "/carts",
    resource: "carts",
    subMenu: [
      {
        id: "cart-list",
        title: "Cart List",
        navLink: "/carts/cart-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "distribution",
    title: "Distribution & Planning",
    icon: faBus,
    navLink: "/distribution",
    resource: "distribution",
    subMenu: [
      // {
      //   id: "production-plan-list",
      //   title: "Production Plans",
      //   navLink: "/distribution/orderManagement",
      //   icon: faCircle,
      // },
      // {
      //   id: "cartAllocation-list",
      //   title: "Cart Allocation Pre Planning",
      //   navLink: "/distribution/cartAllocation",
      //   icon: faCircle,
      // },
      // {
      //   id: "distributionPlan-list",
      //   title: "Direct Sale Allocation",
      //   navLink: "/distribution/directSaleAllocation",
      //   icon: faCircle,
      // },
      {
        id: "cart-loading",
        title: "Cart Loading Management",
        navLink: "/distribution/cart-loading",
        icon: faCircle,
      },
      {
        id: "cart-configuration",
        title: "Cart Configuration",
        navLink: "/distribution/cart-configuration",
        icon: faCircle,
      },
    ],
  },
  {
    id: "allocation",
    title: "Allocation",
    icon: faBus,
    navLink: "/allocation",
    resource: "allocation",
    subMenu: [{
      id: "create-allocation-request",
      title: "Create Allocation Request",
      navLink: "/allocation/create-request",
      icon: faCircle,
    },
  {
      id: "allocation-process",
      title: "Allocation System",
      navLink: "/allocation/allocation-process",
      icon: faCircle,
  }]

  }
];


// 🔥 Remove the deprecated function call and export the raw navigation
// const verticalNavigation = getNavigationWithPermissions(fullNavigation); // ❌ REMOVE THIS LINE

// 🔥 Just export the full navigation - components will use the hook
export default fullNavigation;

// 🔥 Optional: Keep this function if other parts of your app need it, but make it return the hook
export const useVerticalNavigation = () => {
  return useNavigationWithPermissions(fullNavigation);
};

